if (!customElements.get('custom-card-video')) {
  class CustomCardVideo extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.custom-card-slider__play-pause-button');
      this.video = this.querySelector('video');

      if (this.video && this.button) {
        this.button.addEventListener('click', () => {
          this.button.classList.toggle('play');
          this.video.paused ? this.video.play() : this.video.pause();
        })
      }
    }
  }

  customElements.define('custom-card-video', CustomCardVideo);
}